import {Inject, Injectable} from '@angular/core';
import {Observable, ReplaySubject} from "rxjs";
import {CountedAndPaginated} from "../interface/response/counted-and-paginated";
import {Document as DocumentInterface} from "../interface/document";
import {Newsletter} from "../interface/newsletter";
import {HttpClient} from "@angular/common/http";
import {FilterService} from "./filter.service";
import {DOCUMENT} from "@angular/common";
import {Uuid} from "../interface/response/uuid";
import {first, take} from "rxjs/operators";
import {ListResponse} from "../interface/response/list-response";
import {SettlementTemplate} from "../interface/settlement-template";
import {Contract} from "../interface/contract";

@Injectable({
  providedIn: 'root'
})
export class NewsletterService {
  private readonly newsletterListSubject: ReplaySubject<CountedAndPaginated<Newsletter>>
    = new ReplaySubject<CountedAndPaginated<Newsletter>>(1);
  constructor(
    private httpClient: HttpClient,
    private filterService: FilterService,
    @Inject(DOCUMENT) private document: Document
  ) { }

  public sendForm(formData: object, newsletterId?: string): Observable<Uuid> {
    if (newsletterId) {
      return this.httpClient.put(`/rest/crm/newsletter/${newsletterId}`, formData)
        .pipe(
          take(1)
        ) as Observable<Uuid>;
    } else {
      return this.httpClient.post('/rest/crm/newsletter', formData)
        .pipe(
          take(1)
        ) as Observable<Uuid>;
    }
  }
  public loadList(page: number, pageSize: number, filters: object): void {
    this.httpClient.get(`/rest/crm/newsletter?page=${page + 1}&pageSize=${pageSize}&` + this.filterService.parseFilters(filters))
      .pipe(
        first()
      )
      .subscribe((result: CountedAndPaginated<Newsletter>) => {
        this.newsletterListSubject.next(result);
      });
  }
  public getNewsletterListSubject(): ReplaySubject<CountedAndPaginated<Newsletter>> {
    return this.newsletterListSubject;
  }


  public get(newsletterId: string): Observable<Newsletter> {
    return this.httpClient.get(`/rest/crm/newsletter/${newsletterId}`)
      .pipe(first()) as Observable<Newsletter>;
  }

  public getCurrent(): Observable<Newsletter> {
    return this.httpClient.get(`/rest/crm/newsletter/current`)
        .pipe(first()) as Observable<Newsletter>;
  }
  public downloadFile(uuid: string): void {
    this.document.location.href = `/rest/crm/newsletter/${uuid}/downloadFile`;
  }
  public deleteNewsletter(uuid: string): Observable<any> {
    return this.httpClient.delete(`/rest/crm/newsletter/${uuid}`)
      .pipe(first());
  }
}
